/* eslint-disable */
import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { actions } from "./reducer";
import { actions as appActions } from "../App";

class ReservationManager extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return <div className={styles.container}></div>;
  }
}

export default connect(createStructuredSelector({}), dispatch =>
  bindActionCreators({ ...actions, ...appActions }, dispatch)
)(ReservationManager);

ReservationManager.propTypes = {};
